import React from 'react';
import { createRoot } from 'react-dom/client';
import { Router } from 'react-router-dom';
import {Provider} from 'react-redux';
import Immutable from 'immutable';
import installDevTools from 'immutable-devtools';
//
import AppRouter from './js/router/Router';
import configureStore from './js/store/configureStore';
import history from './js/history';
import './js/components/Questionnaire';
import Questionnaire from "./js/components/Questionnaire";

const store = configureStore();

// import './css/index.css';
// import './scss/index.scss';

// import App from './js/App';
// import registerServiceWorker from './js/registerServiceWorker';
//
// ReactDOM.render(<App />, document.getElementById('react_root'));
// registerServiceWorker();

// Routes

if (process.env.NODE_ENV === "development") {
	installDevTools(Immutable);
}

function main() {
	document.addEventListener('DOMContentLoaded', () => {
		const container = document.getElementById('react_questionnaire_root');
		
		if (container) {
			const root = createRoot(container);
			root.render(<Questionnaire/>);
		}
	})
	
	const container = document.getElementById('react_root');
	const root = createRoot(container);
	root.render(
		<Provider store={store}>
			<Router history={history}>
				<AppRouter/>
			</Router>
		</Provider>
	);
}

main();



// WEBPACK FOOTER //
// ./src/index.js